import axios from '../../../axios'


// 编辑
export const edit = (data) => {
  return axios({
    url: '/workorder/woInsepctionDevice/edit',
    method: 'post',
    data
  })
}

// 删除
export const singleDelete = (data) => {
  return axios({
    url: '/workorder/woInsepctionDevice/delete',
    method: 'post',
    data
  })
}

// 保存
export const save = (data) => {
  return axios({
    url: '/workorder/woInsepctionDevice/save',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/biz/workorder/woInspectionDevice.js